// src/components/AboutUs/AboutUs.js
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import './AboutUs.css';
import { ABOUT_US_TITLE, ABOUT_US_DESCRIPTION, SECTION_IDS } from '../../constants';
import aboutUsImg from '../../assets/aboutUs.jpeg'; // Ensure this path is correct

const AboutUs = () => {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  return (
    <section className="about-us" id={SECTION_IDS.ABOUT}>
      <div className={`about-us-content ${isDesktop ? 'desktop' : 'mobile'}`}>
        {isDesktop && (
          <div className="about-us-image-content">
            <img src={aboutUsImg} alt="About Ashtowers" className="about-us-image" />
          </div>
        )}
        <div className="about-us-text-content">
          <h2>{ABOUT_US_TITLE}</h2>
          <p>{ABOUT_US_DESCRIPTION}</p>
        </div>
        {!isDesktop && (
          <div className="about-us-image-content mobile-image">
            {/* You might want a different or simplified image for mobile, or use the same one */}
            <img src={aboutUsImg} alt="About Ashtowers" className="about-us-image" />
          </div>
        )}
      </div>
    </section>
  );
};

export default AboutUs;
